export const customTimezones = {
    "tzCode": "tzCode",
    "Pacific/Niue": "Pacific/Niue",
    "Pacific/Pago_Pago": "Pacific/Pago_Pago",
    "America/Adak": "America/Adak",
    "Pacific/Honolulu": "Pacific/Honolulu",
    "Pacific/Rarotonga": "Pacific/Rarotonga",
    "Pacific/Tahiti": "Pacific/Tahiti",
    "Pacific/Marquesas": "Pacific/Marquesas",
    "America/Anchorage": "America/Anchorage",
    "America/Juneau": "America/Juneau",
    "America/Metlakatla": "America/Metlakatla",
    "America/Nome": "America/Nome",
    "America/Sitka": "America/Sitka",
    "America/Yakutat": "America/Yakutat",
    "Pacific/Gambier": "Pacific/Gambier",
    "America/Los_Angeles": "America/Los_Angeles",
    "America/Tijuana": "America/Tijuana",
    "America/Vancouver": "America/Vancouver",
    "Pacific/Pitcairn": "Pacific/Pitcairn",
    "America/Boise": "America/Boise",
    "America/Cambridge_Bay": "America/Cambridge_Bay",
    "America/Chihuahua": "America/Chihuahua",
    "America/Creston": "America/Creston",
    "America/Dawson": "America/Dawson",
    "America/Dawson_Creek": "America/Dawson_Creek",
    "America/Denver": "America/Denver",
    "America/Edmonton": "America/Edmonton",
    "America/Fort_Nelson": "America/Fort_Nelson",
    "America/Hermosillo": "America/Hermosillo",
    "America/Inuvik": "America/Inuvik",
    "America/Mazatlan": "America/Mazatlan",
    "America/Ojinaga": "America/Ojinaga",
    "America/Phoenix": "America/Phoenix",
    "America/Whitehorse": "America/Whitehorse",
    "America/Yellowknife": "America/Yellowknife",
    "America/Bahia_Banderas": "America/Bahia_Banderas",
    "America/Belize": "America/Belize",
    "America/Chicago": "America/Chicago",
    "America/Costa_Rica": "America/Costa_Rica",
    "America/El_Salvador": "America/El_Salvador",
    "America/Guatemala": "America/Guatemala",
    "America/Indiana/Knox": "America/Indiana/Knox",
    "America/Indiana/Tell_City": "America/Indiana/Tell_City",
    "America/Managua": "America/Managua",
    "America/Matamoros": "America/Matamoros",
    "America/Menominee": "America/Menominee",
    "America/Merida": "America/Merida",
    "America/Mexico_City": "America/Mexico_City",
    "America/Monterrey": "America/Monterrey",
    "America/North_Dakota/Beulah": "America/North_Dakota/Beulah",
    "America/North_Dakota/Center": "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem": "America/North_Dakota/New_Salem",
    "America/Rainy_River": "America/Rainy_River",
    "America/Rankin_Inlet": "America/Rankin_Inlet",
    "America/Regina": "America/Regina",
    "America/Resolute": "America/Resolute",
    "America/Swift_Current": "America/Swift_Current",
    "America/Tegucigalpa": "America/Tegucigalpa",
    "America/Winnipeg": "America/Winnipeg",
    "Pacific/Easter": "Pacific/Easter",
    "Pacific/Galapagos": "Pacific/Galapagos",
    "America/Atikokan": "America/Atikokan",
    "America/Bogota": "America/Bogota",
    "America/Cancun": "America/Cancun",
    "America/Cayman": "America/Cayman",
    "America/Detroit": "America/Detroit",
    "America/Eirunepe": "America/Eirunepe",
    "America/Grand_Turk": "America/Grand_Turk",
    "America/Guayaquil": "America/Guayaquil",
    "America/Havana": "America/Havana",
    "America/Indiana/Indianapolis": "America/Indiana/Indianapolis",
    "America/Indiana/Marengo": "America/Indiana/Marengo",
    "America/Indiana/Petersburg": "America/Indiana/Petersburg",
    "America/Indiana/Vevay": "America/Indiana/Vevay",
    "America/Indiana/Vincennes": "America/Indiana/Vincennes",
    "America/Indiana/Winamac": "America/Indiana/Winamac",
    "America/Iqaluit": "America/Iqaluit",
    "America/Jamaica": "America/Jamaica",
    "America/Kentucky/Louisville": "America/Kentucky/Louisville",
    "America/Kentucky/Monticello": "America/Kentucky/Monticello",
    "America/Lima": "America/Lima",
    "America/Nassau": "America/Nassau",
    "America/New_York": "America/New_York",
    "America/Nipigon": "America/Nipigon",
    "America/Panama": "America/Panama",
    "America/Pangnirtung": "America/Pangnirtung",
    "America/Port-au-Prince": "America/Port-au-Prince",
    "America/Rio_Branco": "America/Rio_Branco",
    "America/Thunder_Bay": "America/Thunder_Bay",
    "America/Toronto": "America/Toronto",
    "America/Anguilla": "America/Anguilla",
    "America/Antigua": "America/Antigua",
    "America/Aruba": "America/Aruba",
    "America/Asuncion": "America/Asuncion",
    "America/Barbados": "America/Barbados",
    "America/Blanc-Sablon": "America/Blanc-Sablon",
    "America/Boa_Vista": "America/Boa_Vista",
    "America/Campo_Grande": "America/Campo_Grande",
    "America/Caracas": "America/Caracas",
    "America/Cuiaba": "America/Cuiaba",
    "America/Curacao": "America/Curacao",
    "America/Dominica": "America/Dominica",
    "America/Glace_Bay": "America/Glace_Bay",
    "America/Goose_Bay": "America/Goose_Bay",
    "America/Grenada": "America/Grenada",
    "America/Guadeloupe": "America/Guadeloupe",
    "America/Guyana": "America/Guyana",
    "America/Halifax": "America/Halifax",
    "America/Kralendijk": "America/Kralendijk",
    "America/La_Paz": "America/La_Paz",
    "America/Lower_Princes": "America/Lower_Princes",
    "America/Manaus": "America/Manaus",
    "America/Marigot": "America/Marigot",
    "America/Martinique": "America/Martinique",
    "America/Moncton": "America/Moncton",
    "America/Montserrat": "America/Montserrat",
    "America/Porto_Velho": "America/Porto_Velho",
    "America/Port_of_Spain": "America/Port_of_Spain",
    "America/Puerto_Rico": "America/Puerto_Rico",
    "America/Santiago": "America/Santiago",
    "America/Santo_Domingo": "America/Santo_Domingo",
    "America/St_Barthelemy": "America/St_Barthelemy",
    "America/St_Kitts": "America/St_Kitts",
    "America/St_Lucia": "America/St_Lucia",
    "America/St_Thomas": "America/St_Thomas",
    "America/St_Vincent": "America/St_Vincent",
    "America/Thule": "America/Thule",
    "America/Tortola": "America/Tortola",
    "Atlantic/Bermuda": "Atlantic/Bermuda",
    "America/St_Johns": "America/St_Johns",
    "America/Araguaina": "America/Araguaina",
    "America/Argentina/Buenos_Aires": "America/Argentina/Buenos_Aires",
    "America/Argentina/Catamarca": "America/Argentina/Catamarca",
    "America/Argentina/Cordoba": "America/Argentina/Cordoba",
    "America/Argentina/Jujuy": "America/Argentina/Jujuy",
    "America/Argentina/La_Rioja": "America/Argentina/La_Rioja",
    "America/Argentina/Mendoza": "America/Argentina/Mendoza",
    "America/Argentina/Rio_Gallegos": "America/Argentina/Rio_Gallegos",
    "America/Argentina/Salta": "America/Argentina/Salta",
    "America/Argentina/San_Juan": "America/Argentina/San_Juan",
    "America/Argentina/San_Luis": "America/Argentina/San_Luis",
    "America/Argentina/Tucuman": "America/Argentina/Tucuman",
    "America/Argentina/Ushuaia": "America/Argentina/Ushuaia",
    "America/Bahia": "America/Bahia",
    "America/Belem": "America/Belem",
    "America/Cayenne": "America/Cayenne",
    "America/Fortaleza": "America/Fortaleza",
    "America/Godthab": "America/Godthab",
    "America/Maceio": "America/Maceio",
    "America/Miquelon": "America/Miquelon",
    "America/Montevideo": "America/Montevideo",
    "America/Paramaribo": "America/Paramaribo",
    "America/Punta_Arenas": "America/Punta_Arenas",
    "America/Recife": "America/Recife",
    "America/Santarem": "America/Santarem",
    "America/Sao_Paulo": "America/Sao_Paulo",
    "Antarctica/Palmer": "Antarctica/Palmer",
    "Antarctica/Rothera": "Antarctica/Rothera",
    "Atlantic/Stanley": "Atlantic/Stanley",
    "America/Noronha": "America/Noronha",
    "Atlantic/South_Georgia": "Atlantic/South_Georgia",
    "America/Scoresbysund": "America/Scoresbysund",
    "Atlantic/Azores": "Atlantic/Azores",
    "Atlantic/Cape_Verde": "Atlantic/Cape_Verde",
    "Africa/Abidjan": "Africa/Abidjan",
    "Africa/Accra": "Africa/Accra",
    "Africa/Bamako": "Africa/Bamako",
    "Africa/Banjul": "Africa/Banjul",
    "Africa/Bissau": "Africa/Bissau",
    "Africa/Casablanca": "Africa/Casablanca",
    "Africa/Conakry": "Africa/Conakry",
    "Africa/Dakar": "Africa/Dakar",
    "Africa/El_Aaiun": "Africa/El_Aaiun",
    "Africa/Freetown": "Africa/Freetown",
    "Africa/Lome": "Africa/Lome",
    "Africa/Monrovia": "Africa/Monrovia",
    "Africa/Nouakchott": "Africa/Nouakchott",
    "Africa/Ouagadougou": "Africa/Ouagadougou",
    "Africa/Sao_Tome": "Africa/Sao_Tome",
    "America/Danmarkshavn": "America/Danmarkshavn",
    "Antarctica/Troll": "Antarctica/Troll",
    "Atlantic/Canary": "Atlantic/Canary",
    "Atlantic/Faroe": "Atlantic/Faroe",
    "Atlantic/Madeira": "Atlantic/Madeira",
    "Atlantic/Reykjavik": "Atlantic/Reykjavik",
    "Atlantic/St_Helena": "Atlantic/St_Helena",
    "Europe/Dublin": "Europe/Dublin",
    "Europe/Guernsey": "Europe/Guernsey",
    "Europe/Isle_of_Man": "Europe/Isle_of_Man",
    "Europe/Jersey": "Europe/Jersey",
    "Europe/Lisbon": "Europe/Lisbon",
    "Europe/London": "Europe/London",
    "Africa/Algiers": "Africa/Algiers",
    "Africa/Bangui": "Africa/Bangui",
    "Africa/Brazzaville": "Africa/Brazzaville",
    "Africa/Ceuta": "Africa/Ceuta",
    "Africa/Douala": "Africa/Douala",
    "Africa/Kinshasa": "Africa/Kinshasa",
    "Africa/Lagos": "Africa/Lagos",
    "Africa/Libreville": "Africa/Libreville",
    "Africa/Luanda": "Africa/Luanda",
    "Africa/Malabo": "Africa/Malabo",
    "Africa/Ndjamena": "Africa/Ndjamena",
    "Africa/Niamey": "Africa/Niamey",
    "Africa/Porto-Novo": "Africa/Porto-Novo",
    "Africa/Tunis": "Africa/Tunis",
    "Africa/Windhoek": "Africa/Windhoek",
    "Arctic/Longyearbyen": "Arctic/Longyearbyen",
    "Europe/Amsterdam": "Europe/Amsterdam",
    "Europe/Andorra": "Europe/Andorra",
    "Europe/Belgrade": "Europe/Belgrade",
    "Europe/Berlin": "Europe/Berlin",
    "Europe/Bratislava": "Europe/Bratislava",
    "Europe/Brussels": "Europe/Brussels",
    "Europe/Budapest": "Europe/Budapest",
    "Europe/Copenhagen": "Europe/Copenhagen",
    "Europe/Gibraltar": "Europe/Gibraltar",
    "Europe/Ljubljana": "Europe/Ljubljana",
    "Europe/Luxembourg": "Europe/Luxembourg",
    "Europe/Madrid": "Europe/Madrid",
    "Europe/Malta": "Europe/Malta",
    "Europe/Monaco": "Europe/Monaco",
    "Europe/Oslo": "Europe/Oslo",
    "Europe/Paris": "Europe/Paris",
    "Europe/Podgorica": "Europe/Podgorica",
    "Europe/Prague": "Europe/Prague",
    "Europe/Rome": "Europe/Rome",
    "Europe/San_Marino": "Europe/San_Marino",
    "Europe/Sarajevo": "Europe/Sarajevo",
    "Europe/Skopje": "Europe/Skopje",
    "Europe/Stockholm": "Europe/Stockholm",
    "Europe/Tirane": "Europe/Tirane",
    "Europe/Vaduz": "Europe/Vaduz",
    "Europe/Vatican": "Europe/Vatican",
    "Europe/Vienna": "Europe/Vienna",
    "Europe/Warsaw": "Europe/Warsaw",
    "Europe/Zagreb": "Europe/Zagreb",
    "Europe/Zurich": "Europe/Zurich",
    "Africa/Blantyre": "Africa/Blantyre",
    "Africa/Bujumbura": "Africa/Bujumbura",
    "Africa/Cairo": "Africa/Cairo",
    "Africa/Gaborone": "Africa/Gaborone",
    "Africa/Harare": "Africa/Harare",
    "Africa/Johannesburg": "Africa/Johannesburg",
    "Africa/Juba": "Africa/Juba",
    "Africa/Khartoum": "Africa/Khartoum",
    "Africa/Kigali": "Africa/Kigali",
    "Africa/Lubumbashi": "Africa/Lubumbashi",
    "Africa/Lusaka": "Africa/Lusaka",
    "Africa/Maputo": "Africa/Maputo",
    "Africa/Maseru": "Africa/Maseru",
    "Africa/Mbabane": "Africa/Mbabane",
    "Africa/Tripoli": "Africa/Tripoli",
    "Asia/Amman": "Asia/Amman",
    "Asia/Beirut": "Asia/Beirut",
    "Asia/Damascus": "Asia/Damascus",
    "Asia/Famagusta": "Asia/Famagusta",
    "Asia/Gaza": "Asia/Gaza",
    "Asia/Hebron": "Asia/Hebron",
    "Asia/Jerusalem": "Asia/Jerusalem",
    "Asia/Nicosia": "Asia/Nicosia",
    "Asia/Saigon": "Asia/Saigon",
    "Europe/Athens": "Europe/Athens",
    "Europe/Bucharest": "Europe/Bucharest",
    "Europe/Chisinau": "Europe/Chisinau",
    "Europe/Helsinki": "Europe/Helsinki",
    "Europe/Kaliningrad": "Europe/Kaliningrad",
    "Europe/Kyiv": "Europe/Kyiv",
    "Europe/Mariehamn": "Europe/Mariehamn",
    "Europe/Riga": "Europe/Riga",
    "Europe/Sofia": "Europe/Sofia",
    "Europe/Tallinn": "Europe/Tallinn",
    "Europe/Uzhgorod": "Europe/Uzhgorod",
    "Europe/Vilnius": "Europe/Vilnius",
    "Europe/Zaporizhzhia": "Europe/Zaporizhzhia",
    "Africa/Addis_Ababa": "Africa/Addis_Ababa",
    "Africa/Asmara": "Africa/Asmara",
    "Africa/Dar_es_Salaam": "Africa/Dar_es_Salaam",
    "Africa/Djibouti": "Africa/Djibouti",
    "Africa/Kampala": "Africa/Kampala",
    "Africa/Mogadishu": "Africa/Mogadishu",
    "Africa/Nairobi": "Africa/Nairobi",
    "Antarctica/Syowa": "Antarctica/Syowa",
    "Asia/Aden": "Asia/Aden",
    "Asia/Baghdad": "Asia/Baghdad",
    "Asia/Bahrain": "Asia/Bahrain",
    "Asia/Kuwait": "Asia/Kuwait",
    "Asia/Qatar": "Asia/Qatar",
    "Asia/Riyadh": "Asia/Riyadh",
    "Europe/Istanbul": "Europe/Istanbul",
    "Europe/Kirov": "Europe/Kirov",
    "Europe/Minsk": "Europe/Minsk",
    "Europe/Moscow": "Europe/Moscow",
    "Europe/Simferopol": "Europe/Simferopol",
    "Europe/Volgograd": "Europe/Volgograd",
    "Indian/Antananarivo": "Indian/Antananarivo",
    "Indian/Comoro": "Indian/Comoro",
    "Indian/Mayotte": "Indian/Mayotte",
    "Asia/Tehran": "Asia/Tehran",
    "Asia/Baku": "Asia/Baku",
    "Asia/Dubai": "Asia/Dubai",
    "Asia/Muscat": "Asia/Muscat",
    "Asia/Tbilisi": "Asia/Tbilisi",
    "Asia/Yerevan": "Asia/Yerevan",
    "Europe/Astrakhan": "Europe/Astrakhan",
    "Europe/Samara": "Europe/Samara",
    "Europe/Saratov": "Europe/Saratov",
    "Europe/Ulyanovsk": "Europe/Ulyanovsk",
    "Indian/Mahe": "Indian/Mahe",
    "Indian/Mauritius": "Indian/Mauritius",
    "Indian/Reunion": "Indian/Reunion",
    "Asia/Kabul": "Asia/Kabul",
    "Antarctica/Mawson": "Antarctica/Mawson",
    "Asia/Aqtau": "Asia/Aqtau",
    "Asia/Aqtobe": "Asia/Aqtobe",
    "Asia/Ashgabat": "Asia/Ashgabat",
    "Asia/Atyrau": "Asia/Atyrau",
    "Asia/Dushanbe": "Asia/Dushanbe",
    "Asia/Karachi": "Asia/Karachi",
    "Asia/Oral": "Asia/Oral",
    "Asia/Qyzylorda": "Asia/Qyzylorda",
    "Asia/Samarkand": "Asia/Samarkand",
    "Asia/Tashkent": "Asia/Tashkent",
    "Asia/Yekaterinburg": "Asia/Yekaterinburg",
    "Indian/Kerguelen": "Indian/Kerguelen",
    "Indian/Maldives": "Indian/Maldives",
    "Asia/Colombo": "Asia/Colombo",
    "Asia/Kolkata": "Asia/Kolkata",
    "Asia/Kathmandu": "Asia/Kathmandu",
    "Antarctica/Vostok": "Antarctica/Vostok",
    "Asia/Almaty": "Asia/Almaty",
    "Asia/Bishkek": "Asia/Bishkek",
    "Asia/Dhaka": "Asia/Dhaka",
    "Asia/Omsk": "Asia/Omsk",
    "Asia/Qostanay": "Asia/Qostanay",
    "Asia/Thimphu": "Asia/Thimphu",
    "Asia/Urumqi": "Asia/Urumqi",
    "Indian/Chagos": "Indian/Chagos",
    "Asia/Yangon": "Asia/Yangon",
    "Indian/Cocos": "Indian/Cocos",
    "Antarctica/Davis": "Antarctica/Davis",
    "Asia/Bangkok": "Asia/Bangkok",
    "Asia/Barnaul": "Asia/Barnaul",
    "Asia/Hovd": "Asia/Hovd",
    "Asia/Ho_Chi_Minh": "Asia/Ho_Chi_Minh",
    "Asia/Jakarta": "Asia/Jakarta",
    "Asia/Krasnoyarsk": "Asia/Krasnoyarsk",
    "Asia/Novokuznetsk": "Asia/Novokuznetsk",
    "Asia/Novosibirsk": "Asia/Novosibirsk",
    "Asia/Phnom_Penh": "Asia/Phnom_Penh",
    "Asia/Pontianak": "Asia/Pontianak",
    "Asia/Tomsk": "Asia/Tomsk",
    "Asia/Vientiane": "Asia/Vientiane",
    "Indian/Christmas": "Indian/Christmas",
    "Asia/Brunei": "Asia/Brunei",
    "Asia/Choibalsan": "Asia/Choibalsan",
    "Asia/Hong_Kong": "Asia/Hong_Kong",
    "Asia/Irkutsk": "Asia/Irkutsk",
    "Asia/Kuala_Lumpur": "Asia/Kuala_Lumpur",
    "Asia/Kuching": "Asia/Kuching",
    "Asia/Macau": "Asia/Macau",
    "Asia/Makassar": "Asia/Makassar",
    "Asia/Manila": "Asia/Manila",
    "Asia/Shanghai": "Asia/Shanghai",
    "Asia/Singapore": "Asia/Singapore",
    "Asia/Taipei": "Asia/Taipei",
    "Asia/Ulaanbaatar": "Asia/Ulaanbaatar",
    "Australia/Perth": "Australia/Perth",
    "Australia/Eucla": "Australia/Eucla",
    "Asia/Chita": "Asia/Chita",
    "Asia/Dili": "Asia/Dili",
    "Asia/Jayapura": "Asia/Jayapura",
    "Asia/Khandyga": "Asia/Khandyga",
    "Asia/Pyongyang": "Asia/Pyongyang",
    "Asia/Seoul": "Asia/Seoul",
    "Asia/Tokyo": "Asia/Tokyo",
    "Asia/Yakutsk": "Asia/Yakutsk",
    "Pacific/Palau": "Pacific/Palau",
    "Australia/Adelaide": "Australia/Adelaide",
    "Australia/Broken_Hill": "Australia/Broken_Hill",
    "Australia/Darwin": "Australia/Darwin",
    "Antarctica/DumontDUrville": "Antarctica/DumontDUrville",
    "Antarctica/Macquarie": "Antarctica/Macquarie",
    "Asia/Ust-Nera": "Asia/Ust-Nera",
    "Asia/Vladivostok": "Asia/Vladivostok",
    "Australia/Brisbane": "Australia/Brisbane",
    "Australia/Currie": "Australia/Currie",
    "Australia/Hobart": "Australia/Hobart",
    "Australia/Lindeman": "Australia/Lindeman",
    "Australia/Melbourne": "Australia/Melbourne",
    "Australia/Sydney": "Australia/Sydney",
    "Pacific/Chuuk": "Pacific/Chuuk",
    "Pacific/Guam": "Pacific/Guam",
    "Pacific/Port_Moresby": "Pacific/Port_Moresby",
    "Pacific/Saipan": "Pacific/Saipan",
    "Australia/Lord_Howe": "Australia/Lord_Howe",
    "Antarctica/Casey": "Antarctica/Casey",
    "Asia/Magadan": "Asia/Magadan",
    "Asia/Sakhalin": "Asia/Sakhalin",
    "Asia/Srednekolymsk": "Asia/Srednekolymsk",
    "Pacific/Bougainville": "Pacific/Bougainville",
    "Pacific/Efate": "Pacific/Efate",
    "Pacific/Guadalcanal": "Pacific/Guadalcanal",
    "Pacific/Kosrae": "Pacific/Kosrae",
    "Pacific/Norfolk": "Pacific/Norfolk",
    "Pacific/Noumea": "Pacific/Noumea",
    "Pacific/Pohnpei": "Pacific/Pohnpei",
    "Antarctica/McMurdo": "Antarctica/McMurdo",
    "Asia/Anadyr": "Asia/Anadyr",
    "Asia/Kamchatka": "Asia/Kamchatka",
    "Pacific/Auckland": "Pacific/Auckland",
    "Pacific/Fiji": "Pacific/Fiji",
    "Pacific/Funafuti": "Pacific/Funafuti",
    "Pacific/Kwajalein": "Pacific/Kwajalein",
    "Pacific/Majuro": "Pacific/Majuro",
    "Pacific/Nauru": "Pacific/Nauru",
    "Pacific/Tarawa": "Pacific/Tarawa",
    "Pacific/Wake": "Pacific/Wake",
    "Pacific/Wallis": "Pacific/Wallis",
    "Pacific/Chatham": "Pacific/Chatham",
    "Pacific/Apia": "Pacific/Apia",
    "Pacific/Enderbury": "Pacific/Enderbury",
    "Pacific/Fakaofo": "Pacific/Fakaofo",
    "Pacific/Tongatapu": "Pacific/Tongatapu",
    "Pacific/Kiritimati": "Pacific/Kiritimati"



}